import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import InformationBanner from '../components/information-banner';
import { site } from '../utils/current-site';

const paths = [
  // specific for damp and mould pages
  '/housing_advice/repairs/damp_and_mould_in_rented_homes',
  '/housing_advice/repairs/damp_and_mould_in_council_and_housing_association_homes',
  '/housing_advice/repairs/landlord_and_tenant_responsibilities_for_repairs',
  '/housing_advice/repairs/legal_action_if_your_landlord_wont_do_repairs',
  '/housing_advice/repairs/legal_action_if_your_landlord_wont_do_repairs/negotiate',
  '/housing_advice/repairs/legal_action_if_your_landlord_wont_do_repairs/ombudsman_compensation',
  '/housing_advice/repairs/legal_action_if_your_landlord_wont_do_repairs/time_limits_small_claims',
  '/housing_advice/repairs/legal_action_if_your_landlord_wont_do_repairs/evidence',
  '/housing_advice/repairs/legal_action_if_your_landlord_wont_do_repairs/letter_of_claim',
  '/housing_advice/repairs/legal_action_if_your_landlord_wont_do_repairs/court_forms_and_hearings',
  '/housing_advice/repairs/how_to_report_repairs_to_a_private_landlord',
  '/housing_advice/repairs/how_to_report_repairs_to_a_council_or_housing_association_landlord/how_to_ask_for_repairs_in_your_council_or_housing_association_home',
  '/housing_advice/repairs/how_to_report_repairs_to_a_council_or_housing_association_landlord/contact_your_landlord_again_if_the_work_is_not_done',
  '/housing_advice/repairs/how_to_report_repairs_to_a_council_or_housing_association_landlord/tell_your_landlord_about_problems_during_repairs',
  '/housing_advice/repairs/how_to_report_repairs_to_a_council_or_housing_association_landlord/complain_to_your_landlord_about_repairs',
  '/housing_advice/repairs/how_to_report_repairs_to_a_council_or_housing_association_landlord/complain_to_the_housing_ombudsman_about_repairs',
  '/housing_advice/repairs/how_to_report_repairs_to_a_council_or_housing_association_landlord',
  '/housing_advice/repairs/is_your_home_fit_for_habitation',
  '/housing_advice/repairs/how_long_should_a_private_landlord_take_to_do_repairs',
  '/housing_advice/repairs/revenge_eviction_if_you_ask_for_repairs',
  '/housing_advice/repairs/check_if_your_home_is_overcrowded_by_law',
  '/housing_advice/repairs/complain_to_environmental_health_about_private_rented_housing',
  '/housing_advice/repairs/what_to_do_if_your_private_landlord_wont_do_repairs',
  '/housing_advice/repairs/compensation_for_disrepair_and_poor_conditions',
  '/housing_advice/repairs/pests_and_vermin_infestations_in_rented_homes',
  '/housing_advice',
  '/housing_advice/eviction/section_21_eviction',
  '/housing_advice/homelessness/emergency_housing_from_the_council',
  '/housing_advice/benefits/emergency_grants_loans_and_money_help',
  '/housing_advice/homelessness',
  '/housing_advice/private_renting',
  '/housing_advice/eviction/section_21_eviction/how_to_check_a_section_21_notice_is_valid',
  '/housing_advice/private_renting/how_to_find_landlords_who_accept_benefits',
  '/housing_advice/eviction/section_21_eviction/how_long_a_section_21_eviction_takes',
  '/housing_advice/private_renting/guarantors_for_private_renters',
  '/housing_advice/eviction/section_21_eviction/staying_after_a_section_21_notice',
  '/housing_advice/homelessness/get_help_from_the_council',
  '/housing_advice/private_renting/rent_increases',
  '/housing_advice/homelessness/priority_need',
  '/housing_advice/private_renting/how_to_end_a_fixed_term_tenancy_early',
  '/housing_advice/homelessness/emergency_housing_from_the_council/how_to_get_emergency_housing',
  '/housing_advice/homelessness/get_help_from_the_council/how_to_ask_the_council_for_help',
  '/housing_advice/tenancy_deposits/holding_deposits',
  '/housing_advice/private_renting/rent_deposit_bond_and_guarantee_schemes',
  '/housing_advice/eviction/eviction_after_a_section_8_notice',
  '/housing_advice/private_renting/assured_shorthold_tenancies_with_private_landlords',
  '/housing_advice/private_renting/options_when_your_fixed_term_tenancy_ends',
  '/housing_advice/homelessness/temporary_housing_when_homeless',
  '/housing_advice/private_renting/ending_a_periodic_tenancy/example_of_a_notice_to_quit',
  '/housing_advice/council_housing_association/how_to_apply_for_council_housing/how_long_does_it_take_to_get_a_council_home',
  '/housing_advice/benefits/local_housing_allowance_lha_for_private_renters',
  '/housing_advice/private_renting/how_to_end_a_fixed_term_tenancy_early/use_a_break_clause',
  '/housing_advice/homelessness/emergency_housing_from_the_council/types_of_emergency_housing',
];

const matchPath = (path) => {
  if (paths.includes(path)) return true;
};

export const useResearchBanner = (path) => {
  const { contentfulComponentInformationBanner: banner } =
    useStaticQuery(graphql`
      query researchBanner {
        contentfulComponentInformationBanner(
          contentful_id: { eq: "1lZ7XDCfRjI0b8qXWfSaFv" }
        ) {
          ...InformationBannerFragment
        }
      }
    `);

  if (!banner || site !== 'england' || !matchPath(path)) return null;

  return (
    <InformationBanner
      color={banner.color}
      metadata={banner.metadata}
      text={banner.text}
    />
  );
};
